class LinkedProducts {
  constructor(currentColor, currentColorOutput, linkedItems) {
    this.currentColor = currentColor;
    this.currentColorOutput = currentColorOutput;
    this.linkedItems = linkedItems;

    this.init = this.init.bind(this);

    this.init();
  }

  init() {
    this.linkedItems.forEach((item) => {
      item.addEventListener('mouseover', (e) => {
        const { color } = e.currentTarget.dataset;
        this.currentColorOutput.textContent = color;
      });

      item.addEventListener('mouseout', () => {
        this.currentColorOutput.textContent = this.currentColor;
      });
    });
  }
}

export default LinkedProducts;
